// Types
type Language = 'EN' | 'FR';

export type I18nResources = {
  [brand: string]: {
    [lang in Language]: {
      [key: string]: Record<string, string | Record<string, string>>;
    };
  };
};

const i18nCustomResources: I18nResources = {
  'christianlouboutin': {
    EN: {
      header: {
        'REWARDS': 'MY EXPERIENCES',
      },
      common: {
        'back': 'BACK',
        'date': 'DATE',
      },
      rewards: {
        'subtitle': 'All the exclusive experiences that you have unlocked by purchasing products.',
        'my_invitations': 'My invitations',
        'my_memories': 'My memories',
        'scheduling_services': 'Scheduling services',
        'loyalty_rewards': 'Loyalty rewards',
        'whats_new': "WHAT'S NEW",
        'receive_invitation': 'RECEIVE MY INVITATION',
      },
      invitations: {
        'title': 'MY INVITATIONS',
        'subtitle': 'All the exclusive invitations that you have unlocked by purchasing products.',
        'new_shop': 'New opening shop',
        'new_shop_title': 'Invitation to our new store',
        'new_shop_description': 'We are pleased to invite you to take advantage of our exclusive invitation-only sales, reserved especially for owners.',
        'jaden_smith': "Jaden Smith's first collection",
        'jaden_smith_title': "Invitation to Jaden Smith's first collection",
        'jaden_smith_description': "Christian Louboutin unveils Jaden Smith's first Fall-Winter 2026 menswear collection, presented through an immersive exhibition blending music, visual arts, fashion, and history, celebrating the brand's heritage while outlining its future.",
        'private_sale': 'Private sale',
        'private_sale_title': 'Exclusive Private Sale',
        'private_sale_description': 'As a valued owner, you are invited to our exclusive private sale event. Enjoy early access to our latest collections and special discounts reserved only for our most loyal clients.',
        'hotel': 'Christian Louboutin Hotel',
        'hotel_title': 'Christian Louboutin Hotel Opening',
        'hotel_description': 'We invite you to the grand opening of the first Christian Louboutin Hotel — an immersive experience where fashion, art, and luxury hospitality converge in the heart of Paris.',
        'collection_preview': 'Collection preview',
        'collection_preview_title': 'Fall-Winter 2026 Collection Preview',
        'collection_preview_description': 'You are cordially invited to an exclusive preview of the Fall-Winter 2026 collection, presented in an intimate setting before its public debut. Discover the new silhouettes and iconic pieces ahead of the season.',
        'pe26': 'PE26 Femme "Paris is Louboutining"',
        'pe26_title': 'PE26 Femme — Paris is Louboutining',
        'pe26_description': 'Join us for the Spring-Summer 2026 womenswear presentation, a celebration of Parisian femininity reimagined through the lens of Christian Louboutin. An evening of fashion, music, and art not to be missed.',
      },
      memories: {
        'title': 'MY MEMORIES',
        'subtitle': 'All the exclusive memories that you have saved with your products.',
      },
    },
    FR: {
      care: {
        'cleaning': 'Remise en beauté',
        'fitting': 'Retouche et ajustements'
      },
      header: {
        'REWARDS': 'MES EXPÉRIENCES',
      },
      common: {
        'back': 'RETOUR',
        'date': 'DATE',
      },
      rewards: {
        'subtitle': 'Toutes les expériences exclusives que vous avez débloquées en achetant des produits.',
        'my_invitations': 'Mes invitations',
        'my_memories': 'Mes souvenirs',
        'scheduling_services': 'Services de rendez-vous',
        'loyalty_rewards': 'Programme de fidélité',
        'whats_new': "QUOI DE NEUF",
        'receive_invitation': 'RECEVOIR MON INVITATION',
      },
      invitations: {
        'title': 'MES INVITATIONS',
        'subtitle': 'Toutes les invitations exclusives que vous avez débloquées en achetant des produits.',
        'new_shop': 'Nouvelle ouverture de boutique',
        'new_shop_title': 'Invitation à notre nouvelle boutique',
        'new_shop_description': 'Nous avons le plaisir de vous inviter à profiter de nos ventes exclusives sur invitation, réservées spécialement aux propriétaires.',
        'jaden_smith': 'Première collection de Jaden Smith',
        'jaden_smith_title': 'Invitation à la première collection de Jaden Smith',
        'jaden_smith_description': "Christian Louboutin dévoile la première collection automne-hiver 2026 de Jaden Smith, présentée à travers une exposition immersive mêlant musique, arts visuels, mode et histoire, célébrant l'héritage de la marque tout en esquissant son avenir.",
        'private_sale': 'Vente privée',
        'private_sale_title': 'Vente privée exclusive',
        'private_sale_description': "En tant que propriétaire privilégié, vous êtes invité à notre événement de vente privée exclusive. Profitez d'un accès anticipé à nos dernières collections et de remises spéciales réservées à nos clients les plus fidèles.",
        'hotel': 'Hôtel Christian Louboutin',
        'hotel_title': "Ouverture de l'Hôtel Christian Louboutin",
        'hotel_description': "Nous vous invitons à l'ouverture du premier Hôtel Christian Louboutin — une expérience immersive où la mode, l'art et l'hospitalité de luxe se rencontrent au cœur de Paris.",
        'collection_preview': 'Avant-première collection',
        'collection_preview_title': 'Avant-première collection Automne-Hiver 2026',
        'collection_preview_description': "Vous êtes cordialement invité à une avant-première exclusive de la collection Automne-Hiver 2026, présentée dans un cadre intimiste avant son lancement public. Découvrez les nouvelles silhouettes et pièces emblématiques en avant-saison.",
        'pe26': 'PE26 Femme « Paris is Louboutining »',
        'pe26_title': 'PE26 Femme — Paris is Louboutining',
        'pe26_description': "Rejoignez-nous pour la présentation de la collection femme Printemps-Été 2026, une célébration de la féminité parisienne revisitée par Christian Louboutin. Une soirée mode, musique et art à ne pas manquer.",
      },
      memories: {
        'title': 'MES SOUVENIRS',
        'subtitle': 'Tous les souvenirs exclusifs que vous avez enregistrés avec vos produits.',
      },
    }
  },
  delcourtedition: {
    EN: {
      auth: {
        'signin': {
          'title': 'Welcome to your private space.',
          'subtitle': 'To log in, please enter your email below.'
        },
        'pin': {
          'title': 'Welcome to your private space.',
        },
      },
      header: {
        'REWARDS': 'MY EXPERIENCES',
      },
      details: {
        "careAndRepair": "Care services",
        "lifebook": "My product lifebook",
        "composition": "Product details",
        "photoDisclaimerTitle": "Non-contractual images",
        "photoDisclaimerText": "the images shown are for illustrative purposes only. The dimensions and finishes of the model shown may differ from the model covered by this certificate of authenticity."
      },
      composition: {
        "materialSplit": "Materials"
      }
    },
    FR: {
      auth: {
        'signin': {
          'title': 'Bienvenue dans votre espace confidentiel.',
          'subtitle': 'Pour vous connecter, veuillez entrer votre email ci-dessous.'
        },
        'pin': {
          'title': 'Bienvenue dans votre espace confidentiel.',
        },
      },
      header: {
        'REWARDS': 'MES EXPÉRIENCES',
      },
      details: {
        "photoDisclaimerTitle": "Photos non contractuelles",
        "photoDisclaimerText": "les photos d'illustration vous sont fournies à titre d'exemple. Les dimensions et finitions du modèle présenté peuvent différer du modèle faisant l'objet du présent certificat d'authenticité."
      },
    },
  },
  collectionparticulière: {
    EN: {
      auth: {
        'signin': {
          'title': 'Welcome to your private space.',
          'subtitle': 'To log in, please enter your email below.'
        },
        'pin': {
          'title': 'Welcome to your private space.',
        },
      },
      header: {
        'REWARDS': 'MY EXPERIENCES',
      },
      details: {
        "careAndRepair": "Care services",
        "lifebook": "My product lifebook",
        "composition": "Product details",
        "photoDisclaimerTitle": "Non-contractual images",
        "photoDisclaimerText": "the images shown are for illustrative purposes only. The dimensions and finishes of the model shown may differ from the model covered by this certificate of authenticity."
      },
      composition: {
        "materialSplit": "Materials"
      }
    },
    FR: {
      auth: {
        'signin': {
          'title': 'Bienvenue dans votre espace confidentiel.',
          'subtitle': 'Pour vous connecter, veuillez entrer votre email ci-dessous.'
        },
        'pin': {
          'title': 'Bienvenue dans votre espace confidentiel.',
        },
      },
      header: {
        'REWARDS': 'MES EXPÉRIENCES',
      },
      details: {
        "photoDisclaimerTitle": "Photos non contractuelles",
        "photoDisclaimerText": "les photos d'illustration vous sont fournies à titre d'exemple. Les dimensions et finitions du modèle présenté peuvent différer du modèle faisant l'objet du présent certificat d'authenticité."
      },
    },
  },
  andréeputman: {
    EN: {
      wallet: {
        "products_one": "{{count}} PIECE",
        "products_other": "{{count}} PIECES",
        "empty": "Your wallet is empty, start by adding a piece"
      },
      header: {
        "WALLET": "MY COLLECTION",
        "REWARDS": "MY PRIVILEGES",
        "SETTINGS": "MY PROFILE"
      },
      rewards: {
        "empty": "Come back later to enjoy some privileges!",
        "past_rewards": "PAST PRIVILEGES",
      },
      details: {
        "project": "Discover the story behind your piece",
        "history": "Discover the story behind your piece",
        "history_subtitle": "Each step tells the story of a place, a moment in time, and a unique history.",
        "lifebook": "Piece lifebook",
        "offerOrSell": "Offer or sell my piece",
        "lostOrStolen": "Lost or stolen piece",
        "composition": "Piece composition",
        "offer": "Offer my piece",
        "sell": "Sell my piece",
        "productDescription": "Piece description",
        "productDetails": "Piece details",
        "productInformation": "Piece information"
      },
      gift: {
        "personalizeCertificate": "Personalize your certificate transfer by offering much more than just a piece !",
        "sharePhotos": "You can also share photos of your piece to share and extend its story ...",
        "modal": {
          "subtitle": "Your piece transfer has been successfully completed. You can send a personalized message to the receiver.",
          "message": "Hello firstname, I am very happy to offer you this piece from brandName. To be able to claim it, along with its digital ownership certificate, and to enjoy all the associated exclusive services, please visit",
        },
      },
      sell: {
        "modal": {
          "subtitle": "Your piece sale has been successfully processed. You can send a personalized message to the receiver.",
          "message": "Hello firstname, I am very happy to transfer this piece from brandName to you. To claim it, along with its digital ownership certificate, and to enjoy all the associated exclusive services, please visit"
        }
      },
      resale: {
        "subtitle": "Resell in one-click and securely your pieces on our second-hand plateform’s partners.",
        "modal": {
          "title": "Piece resold",
          "subtitle": "Your piece has been successfully transferred to our platform’s partners."
        }
      },
      care: {
        "subtitle": "Please select on below the service requested for your piece.",
      },
      lock: {
        "title": "Lost or stolen piece",
        "subtitle": "Please provide a detailed description of the reason for locking the piece.",
        "success": "Piece locked successfully",
        "failure": "Unable to lock the piece. Please try again.",
      },
      unlock: {
        "title": "Unlock my piece",
        "toast": {
          "unlocked": "Piece already unlocked",
          "notFound": "Piece not found"
        },
        "modal": {
          "title": "Piece unlocked",
          "subtitle": "The piece has been successfully unlocked and is now available."
        },
        "info_1": "To quickly identify your piece and",
        "method": "Which method would you like to use to unlock your piece?",
        "nfcInfo": "To scan via NFC, simply bring your phone close to the piece, the chip is located inside the care label.",
      },
      buttons: {
        "addProduct": "ADD A PIECE",
        "lock": "LOCK MY PIECE",
        "unlock": "UNLOCK MY PIECE",
      },
      partners: {
        "empty": "Sorry, no partner for this piece",
      },
      errors: {
        "8000": "Piece not found, please check the unique identifier.",
        "9000": "Piece not found in your wallet.",
        "10000": "Piece not found in your wallet.",
      },
    },
    FR: {
      wallet: {
        "products_one": "{{count}} PIÈCE",
        "products_other": "{{count}} PIÈCES",
        "empty": "Votre wallet est vide, commencez par ajouter une pièce"
      },
      header: {
        "WALLET": "MA COLLECTION",
        "REWARDS": "MES PRIVILÈGES",
        "SETTINGS": "MON PROFIL"
      },
      rewards: {
        "subtitle": "Tous les avantages et services exclusifs que vous avez débloqués en achetant des pièces éligibles.",
        "empty": "Revenez prochainement pour accéder à vos privilèges !",
        "past_rewards": "HISTORIQUE DE MES PRIVILÈGES",
      },
      details: {
        "lifebook": "Carnet de vie de la pièce",
        "offerOrSell": "Offrir ou vendre ma pièce",
        "lostOrStolen": "Pièce perdue ou volée",
        "composition": "Composition de la pièce",
        "project": "Découvrez l’histoire de votre pièce",
        "history": "Découvrez l’histoire de votre pièce",
        "history_subtitle": "Chaque étape raconte un lieu, une époque et une histoire unique.",
        "offer": "Offrir ma pièce",
        "sell": "Vendre ma pièce",
        "productDescription": "Description de la pièce",
        "productDetails": "Détails de la pièce",
        "productInformation": "Informations de la pièce"
      },
      gift: {
        "personalizeCertificate": "Personnalisez le transfert de votre certificat en offrant bien plus qu'une simple pièce !",
        "sharePhotos": "Vous pouvez également partager des photos de votre pièce pour partager et étendre son histoire ...",
        "modal": {
          "subtitle": "Votre pièce a été transferée avec succès. Vous pouvez envoyer un message personnalisé au destinataire.",
          "message": "Bonjour firstname, je suis très heureux de vous offrir cette pièce de brandName. Pour pouvoir le deverrouiller, ainsi que son certificat de propriété numérique, et profiter de tous les services exclusifs associés, veuillez visiter",
        }
      },
      sell: {
        "modal": {
          "subtitle": "La vente de votre pièce a été traitée avec succès. Vous pouvez envoyer un message personnalisé au destinataire.",
          "message": "Bonjour firstname, je suis très heureux de vous transférer cette pièce de brandName. Pour pouvoir le revendiquer, ainsi que son certificat de propriété numérique, et profiter de tous les services exclusifs associés, veuillez visiter"
        }
      },
      resale: {
        "subtitle": "Revendez en un clic et en toute sécurité vos pièces sur les partenaires de notre plateforme d'occasion.",
        "modal": {
          "title": "Pièce revendue",
          "subtitle": "Votre pièce a été transférée avec succès aux partenaires de notre plateforme."
        }
      },
      care: {
        "subtitle": "Veuillez sélectionner ci-dessous le service demandé pour votre pièce.",
      },
      lock: {
        "title": "Pièce perdue ou volée",
        "subtitle": "Veuillez fournir une description détaillée de la raison du verrouillage de la pièce.",
        "success": "Pièce verrouillée avec succès",
        "failure": "Impossible de verrouiller la pièce. Veuillez réessayer.",
      },
      unlock: {
        "title": "Déverrouiller ma pièce",
        "toast": {
          "unlocked": "Pièce déjà déverrouillée",
          "notFound": "Pièce non trouvée"
        },
        "modal": {
          "title": "Pièce déverrouillée",
          "subtitle": "La pièce a été déverrouillée avec succès et est maintenant disponible."
        },
        "info_1": "Pour identifier rapidement votre pièce et",
        "method": "Quelle méthode souhaitez-vous utiliser pour débloquer votre pièce ?",
        "nfcInfo": "Pour scanner via NFC, il suffit d'approcher votre téléphone de la pièce, la puce se situe à l'intérieur de l'étiquette d'entretien.",
      },
      buttons: {
        "addProduct": "AJOUTER UNE PIÈCE",
        "lock": "VERROUILLER MA PIÈCE",
        "unlock": "DÉVERROUILLER MA PIÈCE",
      },
      partners: {
        "empty": "Désolé, aucun partenaire pour cette pièce",
      },
      errors: {
        "8000": "Pièce non trouvée, veuillez vérifier l'identifiant unique.",
        "9000": "Pièce non trouvée dans votre wallet.",
        "10000": "Pièce non trouvée dans votre wallet.",
      }
    }
  }
};

export default i18nCustomResources;